import { inject, Injectable, NgModule } from '@angular/core';
import {
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  TranslocoConfig,
  TRANSLOCO_LOADER,
  TranslocoModule
} from '@ngneat/transloco';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  private readonly translations = new Map<string, Translation>();

  getTranslation(lang: string): Observable<Translation> | Promise<Translation> {
    if (this.translations.has(lang)) {
      return of(this.translations.get(lang));
    }

    return this.http
      .get<Translation>(`${window.location.origin}/assets/i18n/${lang}.json`)
      .pipe(tap((translation) => this.translations.set(lang, translation)));
  }
}

export const translocoConfig: TranslocoConfig = {
  availableLangs: ['en', 'fr'],
  defaultLang: 'en',
  prodMode: !environment.DEV,
  reRenderOnLangChange: true,
  fallbackLang: 'en',
  missingHandler: {
    useFallbackTranslation: true
  }
};

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig
    },
    {
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader
    }
  ]
})
export class TranslocoRootModule {}
